import { VisualizationCard } from "~/modules/visualization/components/VisualizationCard";
import { CompositionChartConfig } from "~/modules/charts/types";
import { CompositionChartProvider } from "./CompositionChartProvider";

// // // //

/**
 * CompositionChartRenderer
 * Renders a composition chart with an optional group-by control.
 */
export function CompositionChartRenderer(props: {
    title: string;
    description: string;
    config: CompositionChartConfig;
}) {
    const { title, description, config } = props;

    return (
        <>
            <CompositionChartProvider
                title={title}
                description={description}
                config={config}
                height={400}
            >
                {({
                    title,
                    description,
                    isLoading,
                    isEmpty,
                    chartEl,
                    emptyEl,
                    loadingEl,
                    customControls,
                }) => (
                    <VisualizationCard
                        title={title}
                        subtitle={description}
                        watermark="bottom-right"
                        cardClassName="@container"
                        wrapperClassNameOverride=""
                        colSpans={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            xxl: 12,
                        }}
                        customControls={customControls}
                    >
                        {isLoading && <>{loadingEl}</>}
                        {!isLoading && isEmpty && <>{emptyEl}</>}
                        {!isLoading && !isEmpty && <>{chartEl}</>}
                    </VisualizationCard>
                )}
            </CompositionChartProvider>
        </>
    );
}
